// extracted by mini-css-extract-plugin
module.exports = {"Checkboxes":"Checkboxes_Checkboxes__1fmvn","Item":"Checkboxes_Item__1gDLN","Info":"Checkboxes_Info__23biU"};